"use client";

import { FC, memo, useRef } from "react";
import { IEventFeedResponse } from "@finbackoffice/websocket-client";
import classNames from "classnames";
import {
    useDate,
    useScrollToSelectedGame,
    useSelectedSportResultsGameId,
    useSportFeedType,
} from "hooks";
import { RouteNames } from "utils/constants";
import ActiveLink from "components/base/active-link/ActiveLink";
import { getSportClassName } from "utils/helpers";
import TeamIcon from "../base/team-icon/TeamIcon";
import styles from "./results-game.module.sass";

interface IProps {
    game: IEventFeedResponse;
}

const ResultsGame: FC<IProps> = ({ game }) => {
    const { betProcessorFeedType } = useSportFeedType();

    const { formatDate } = useDate();

    const selectedGameId = useSelectedSportResultsGameId();

    const gameRef = useRef<HTMLDivElement>(null);
    useScrollToSelectedGame({ selectedGameId, gameRef, gameId: game.id, offset: 6 });

    return (
        <ActiveLink
            href={`/${RouteNames.SPORT}/${RouteNames.RESULTS}/${game.sport_slug}/${
                game.category_id
            }/${game.id}`}
            activeClassName={styles.active}
            className={classNames(
                styles.sportResultsGame,
                styles[getSportClassName(game.sport_id, betProcessorFeedType)],
            )}>
            <>
                <span className={styles.sportResultsGameTime}>
                    {game.scheduled_at && formatDate(new Date(game.scheduled_at), "HH:mm")}
                </span>
                <span className={styles.sportResultsGameTeams}>
                    <span ref={gameRef}>
                        <span>
                            <TeamIcon sportId={game.sport_id} teamId={game.home_team?.id} />
                            {game.home_team?.name}
                        </span>
                        <span>{game.scoreboard?.home_score}</span>
                    </span>
                    <span>
                        <span>
                            <TeamIcon sportId={game.sport_id} teamId={game.away_team?.id} />
                            {game.away_team?.name}
                        </span>
                        <span>{game.scoreboard?.away_score}</span>
                    </span>
                </span>
            </>
        </ActiveLink>
    );
};

export default memo(ResultsGame);
